import React from 'react'
import { LinkCta } from 'common'
import * as styles from './latestEvInsights.module.scss'
import ResellerModal from '../../../modals/ResellerModal'

export default function LatestEvInsights({ title, subtitle, ctas }) {
  return (
    <LinkCta
      className={styles.section}
      title={title}
      subtitle={subtitle}
      // ctas={ctas}
      options={[{ theme: 'gray' }]}
      customCta={() => <CustomCta text={ctas[0].text} />}
    />
  )
}

const CustomCta = ({ text }) => {
  return (
    <div style={{ marginTop: 'var(--sp-7)' }}>
      <ResellerModal text={text} btn theme="gray" />
    </div>
  )
}
